import React, { useState } from 'react';
import Home from './Home';
import Category from './Category';

type Props = {
  onBack: () => void;
  defaultTab: any;
};
export enum SPENDS_PAGE {
  HOME,
  CATEGORY,
}
export const SpendAnalyzerContext = React.createContext({});
const Spends = (props: Props) => {
  const [currentCategory, setCurrentCategory] = useState<string>();

  const renderSpendsPage = () => {
    return <Home onBack={props.onBack} defaultTab={props.defaultTab} />;
  };
  return (
    <SpendAnalyzerContext.Provider
      value={{
        setCurrentCategory,
        currentCategory,
      }}
    >
      <div>{renderSpendsPage()}</div>
    </SpendAnalyzerContext.Provider>
  );
};

export default Spends;
